export interface ILoginModel
{
    UserName: string;
    PassWord: string;
    Token: string;
    Refreshtoken: string;
}

export class LoginModel implements ILoginModel
{
    UserName: string;    
    PassWord: string; 
    Token: string; 
    Refreshtoken: string;
}
